export const NamtechFooter = ({ tone = "auto", className = "" }) => {
  const light = "/brand/namtech-logo-horizontal.svg";
  const dark = "/brand/namtech-logo-horizontal-blanco.svg";
  return (
    <footer data-testid="namtech-footer" className={`safe-bottom pt-5 mt-8 border-t c-line flex items-center justify-center gap-2 text-xs font-mono c-muted ${className}`}>
      <span>Powered by</span>
      <a data-testid="namtech-footer-link" href="https://www.namtech.mx" target="_blank" rel="noopener noreferrer" className="flex items-center opacity-80 hover:opacity-100 transition-opacity">
        {tone === "dark" ? (
          <img src={dark} alt="NAMTECH" width="94" height="16" className="h-4 w-[94px]" />
        ) : (
          <>
            <img src={light} alt="NAMTECH" width="94" height="16" className="h-4 w-[94px] dark:hidden" />
            <img src={dark} alt="NAMTECH" width="94" height="16" className="h-4 w-[94px] hidden dark:block" />
          </>
        )}
      </a>
    </footer>
  );
};
